import React, { useState, useEffect } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { Typography } from "@mui/material";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Notify from "../../../Notify";
import { getData, putData } from "../../../../services/library";
import { registrarAccion, DONDE } from "../../logs/registrarAccion";

function MarcarActivo(props) {
    const [datosCliente, setDatosCliente] = useState(props.cliente);
    const [disBtn, setDisBtn] = useState(false);
  
    const handleClose = () => {
      props.setOpen(false);
    };
  
    const [notificacion, setNotificacion] = useState({
      open: false,
      mensaje: "",
      severity: "",
      color: "",
    });
  
    async function marcarInactivo(e) {
      setDisBtn(true);
      await putData(
        e,
        "/envasado_clientes/" + datosCliente.id,
        {
          activo: 1,
        },
        setNotificacion
      );
      registrarAccion(DONDE.CLIENTES, `Reactivó cliente ${datosCliente.id} - ${datosCliente.razon_social}`);
    }
  
    return (
      <div>
        <Dialog open={props.open} onClose={handleClose}>
          {notificacion && notificacion.open ? (
            <Notify
              mensaje={notificacion.mensaje}
              open={notificacion.open}
              color={notificacion.color}
              handleClose={() => {
                props.actualizar();
                props.setOpen(false);
                setNotificacion({ open: false });
              }}
              severity={notificacion.severity}
            />
          ) : null}
          <form onSubmit={marcarInactivo}>
            <Box backgroundColor={"#1F618D"}>
              <DialogTitle>
                <Typography color="#ffffff" fontSize={20}>
                  Alta de cliente: {datosCliente.razon_social}
                </Typography>
              </DialogTitle>
            </Box>
            <DialogContent>
              <DialogContentText textAlign={"center"}>
                ¿Seguro que quiere dar de Alta al cliente?
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Stack spacing={45} direction="row">
                <Button
                  color="error"
                  disabled={disBtn}
                  variant="contained"
                  onClick={handleClose}
                >
                  Cancelar
                </Button>
                <Button color="success" type="submit" variant="contained" disabled={disBtn}>
                  Confirmar
                </Button>
              </Stack>
            </DialogActions>
          </form>
        </Dialog>
      </div>
  )
}

export default MarcarActivo